import { useActions } from "../../../../../hooks/useActions";
import { useTypedSelector } from "../../../../../hooks/useTypedSelector";
import { useTranslation } from "react-i18next";
import { TypeFilterItemsList } from "../../../../../share/filters";
import { FilterIdsEnum } from "../../../../../store/reducers/_maps/main/mapFilters/types";
import FilterButtonWithModal from "../../../../../share/filters/FilterButtonWithModal";
import CyberSecurityCategoryFilterItem from "../../../../../share/filters/CyberSecurityCategoryFilterItem";

const ServivesCategoryFilter = () => {
  const filterId: FilterIdsEnum = "cybersecurityServiceCategory";
  const { service_category: activeServicesCategories } = useTypedSelector(
    (state) => state.cybersecurityMapFilters
  );

  const categories = useTypedSelector(
    (state) => state.mapCybersecurityInfo.params.categories ?? []
  );

  const listOfCategories = categories;
  const {
    toggleCybersecurityServiceCategory,
    cleanCybersecurityServiceCategory,
    applyFilter,
  } = useActions();

  const handleClick = (option: string) => {
    toggleCybersecurityServiceCategory(option);
    applyFilter();
  };

  const { t } = useTranslation("translation", {
    keyPrefix: "mainPage.mapFilters.cybersecurity.serviceCategoryFilter",
  });

  const title = t("title");
  const pinText =
    activeServicesCategories.length > 0 && activeServicesCategories.length;

  return (
    <FilterButtonWithModal
      title={title}
      filterId={filterId}
      pinText={pinText}
      onClear={() => {
        cleanCybersecurityServiceCategory([]);
      }}
    >
      <TypeFilterItemsList>
        {listOfCategories.sort().map((option: string) => (
          <CyberSecurityCategoryFilterItem
            option={option}
            label={t(`options.${option}`)}
            key={option}
            isActive={activeServicesCategories.includes(option)}
            onClick={() => handleClick(option)}
          />
        ))}
      </TypeFilterItemsList>
    </FilterButtonWithModal>
  );
};

export default ServivesCategoryFilter;
